<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" inline>
      <el-form-item label="申请发货单:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入申请发货单号" clearable />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" clearable />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请输入合同编号" clearable />
      </el-form-item>
      <el-form-item label="客户名称:" prop="agentName">
        <el-input v-model.trim="searchForm.agentName" placeholder="请输入客户名称" clearable />
      </el-form-item>
      <el-form-item label="部门名称:" prop="department">
        <el-input v-model.trim="searchForm.department" placeholder="请输入部门名称" clearable />
      </el-form-item>
      <el-form-item label="销往国家/区域:" prop="overSeasSalesCountry">
        <el-input v-model.trim="searchForm.overSeasSalesCountry" placeholder="请输入销往国家/区域" clearable />
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="salesType">
        <el-select v-model="searchForm.salesType" clearable>
          <el-option label="全部" value="" />
          <el-option v-for="item in internationalSalesType" :key="item.code" :value="item.code" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间:" prop="endTime">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          @change="handleStartTimeChange"
        />
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="审批时间:" prop="approvalTime">
        <el-date-picker
          v-model="searchForm.approvalStartTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          @change="handleApprovalStartTimeChange"
        />
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <el-date-picker
          v-model="searchForm.approvalEndTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptionsApproval"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="default" @click="handleReset">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="isTableLoading" :data="tableData" border>
      <el-table-column label="申请发货单号" prop="deliveryNum" align="left" width="150">
        <template v-slot="{row}">
          <el-button type="text" @click="lookDelivery(row)">
            {{ row.deliveryNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="项目名称" prop="projectName" align="left" min-width="180">
        <template v-slot="{row}">
          <el-button type="text" class="el-btn-text-left" @click="lookContract(row)">
            {{ row.projectName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="合同编号" prop="contractNum" align="left" width="140" />
      <el-table-column label="ERP订单号" prop="erpOrderNum" align="left" width="140" />
      <el-table-column label="客户名称" prop="agentName" align="left" />
      <el-table-column label="订单分类" prop="contractType" align="left" />
      <el-table-column label="申请时间" prop="submitTime" align="left" />
      <el-table-column label="审批时间" prop="approvalTime" align="left" />
      <el-table-column label="现销/赊销" prop="salesType" align="left" />
      <!--<el-table-column label="分配比例" prop="allocationRatio" align="left" />-->
      <el-table-column label="状态信息" prop="wmsState" align="left" />
      <el-table-column
        prop="physicalFlag"
        label="是否含非实物"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.physicalFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="batteryFlag"
        label="是否带电池"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.batteryFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="发货单号" prop="invoiceNum" width="120" align="left">
        <template v-slot="{row}">
          <el-button v-if="row.invoiceNum" class="el-btn-text-left" type="text" @click="lookShippingList(row)">
            {{ row.invoiceNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="物流单号" prop="logisticsNum" align="left">
        <template v-slot="{row}">
          <el-button v-if="row.logisticsNum" class="el-btn-text-left" type="text" @click="lookLogistics(row)">
            {{ row.logisticsNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="handleRevocation(row)">
            撤回
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="pageState.pageSize"
      :current-page.sync="pageState.pageIndex"
      layout="->,total, prev, pager, next, jumper,sizes"
      :total="pageState.total"
      style="margin-top: 10px"
      hide-on-single-page
      @size-change="handlerSizeChange"
      @current-change="handlerCurrentChange"
    />
    <InternationalApplyForDeliveryDialog
      :dialog-visible-from-apply-for-delivery="dialogVisibleFromApplyForDelivery"
      :current-click-data="currentClickData"
      :is-detail="true"
      :show-notes="3"
      is-distri-money
      @on-status-dialog="updateDialogVisibleFromApplyForDelivery"
      @refresh-table="handleReset"
    />
    <InternationalShippingListDialog
      :current-click-data="currentClickData"
      :dialog-visible-from-shipping-list="dialogVisibleFromShippingList"
      @on-status-dialog="updateDialogVisibleFromShippingList"
    />

    <InternationalLogisticsInformationDialog
      :current-click-data="currentClickData"
      :dialog-visible-from-logistics="dialogVisibleFromLogistics"
      @on-status-dialog="updateDialogVisibleFromLogistics"
    />
    <InternationalRevocationDialog
      :dialog-visible-form-revocation="dialogVisibleFormRevocation"
      :current-click-data="currentClickData"
      @on-status-dialog="updateDialogVisibleFromRevocation"
      @table-refresh="handleReset"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getInvoiceHasBeenReviewed } from '@/API/international';
import InternationalShippingListDialog from '@/views/business/components/InternationalShippingListDialog.vue';
import InternationalLogisticsInformationDialog from '@/views/business/components/InternationalLogisticsInformationDialog.vue';
import InternationalApplyForDeliveryDialog from '@/views/business/components/InternationalApplyForDeliveryDialog.vue';
import InternationalRevocationDialog from '@/views/orderPersion/contract/InternationalRevocationDialog.vue';
/**
 * 已审核发货单
 */
export default {
  name: 'InternationalInvoiceHasBeenReviewed',
  components: {
    InternationalRevocationDialog,
    InternationalApplyForDeliveryDialog,
    InternationalLogisticsInformationDialog,
    InternationalShippingListDialog
  },
  data () {
    return {
      searchForm: {
        deliveryNum: '',
        projectName: '',
        contractNum: '',
        agentName: '',
        department: '',
        overSeasSalesCountry: '',
        salesType: '',
        startTime: '',
        endTime: '',
        approvalStartTime: '',
        approvalEndTime: ''
      },
      pageState: {
        pageIndex: 1,
        pageSize: 10,
        total: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            let date = new Date(this.searchForm.startTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pickerOptionsApproval: {
        disabledDate: (time) => {
          if (this.searchForm.approvalStartTime) {
            let date = new Date(this.searchForm.approvalStartTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      tableData: [],
      isTableLoading: false,
      isDetail: true,
      currentClickData: {},
      dialogVisibleFromApplyForDelivery: false,
      dialogVisibleFromShippingList: false,
      dialogVisibleFromLogistics: false,
      dialogVisibleFormRevocation: false
    };
  },
  computed: {
    ...mapState('enumeration', ['internationalSalesType']),
    ...mapState('pagesTemporary', ['OrderPersionContractListTabActive']) //  tabs页的激活码
  },
  watch: {
    OrderPersionContractListTabActive () {
      this.OrderPersionContractListTabActive === '9' && this.handleReset();
    }
  },
  methods: {
    /**
     * 搜索和重置函数
     */
    handleSearch () {
      this.isTableLoading = true;
      let params = {
        pageIndex: this.pageState.pageIndex,
        pageSize: this.pageState.pageSize
      };
      for (let key in this.searchForm) {
        this.searchForm[key] && (params[key] = this.searchForm[key]);
      }
      let haveStartTime = !!this.searchForm.startTime;
      let haveEndTime = !!this.searchForm.endTime;
      let timeParams = {};
      if (haveStartTime && haveEndTime) {
        timeParams = {
          startTime: `${this.searchForm.startTime} 00:00:00`,
          endTime: `${this.searchForm.endTime} 23:59:59`
        };
      } else if (haveStartTime || haveEndTime) {
        if (haveStartTime) {
          timeParams = {
            startTime: `${this.searchForm.startTime} 00:00:00`
          };
        } else {
          timeParams = {
            endTime: `${this.searchForm.endTime} 23:59:59`
          };
        }
      }
      params.approvalStartTime = params.approvalStartTime ? params.approvalStartTime + ' 00:00:00' : void 0;
      params.approvalEndTime = params.approvalEndTime ? params.approvalEndTime + ' 23:59:59' : void 0;
      console.log(params);
      getInvoiceHasBeenReviewed({ ...params, ...timeParams }).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.pageState.total = json.data.total;
          this.isTableLoading = false;
        }
      }).catch(e => {
        this.isTableLoading = false;
      });
    },
    handleReset () {
      this.$refs.searchForm.resetFields();
      this.searchForm.startTime = '';
      this.searchForm.approvalStartTime = '';
      this.searchForm.approvalEndTime = '';
      this.handleSearch();
    },
    handleStartTimeChange (value) {
      let startTime = new Date(value);
      let endTime = new Date(this.searchForm.endTime);
      if (startTime.getTime() > endTime.getTime()) {
        this.searchForm.endTime = undefined;
      }
    },
    handleApprovalStartTimeChange (value) {
      console.log(111);
      let startTime = new Date(value);
      let endTime = new Date(this.searchForm.approvalEndTime);
      if (startTime.getTime() > endTime.getTime()) {
        this.searchForm.approvalEndTime = undefined;
      }
    },
    /**
     * 更改分页器 触发的函数
     * @param value
     */
    handlerSizeChange (value) {
      this.handleSearch();
    },
    handlerCurrentChange (value) {
      this.handleSearch();
    },
    /**
     * 物流单号详情
     */
    lookLogistics (row) {
      this.currentClickData = row;
      this.dialogVisibleFromLogistics = true;
    },
    updateDialogVisibleFromLogistics (value) {
      this.dialogVisibleFromLogistics = value;
    },
    /**
     * 发货清单
     * @param row
     */
    lookShippingList (row) {
      this.currentClickData = row;
      this.dialogVisibleFromShippingList = true;
    },
    updateDialogVisibleFromShippingList (value) {
      this.dialogVisibleFromShippingList = value;
    },
    /**
     * 合同详情 复用的国内
     * @param row
     */
    lookContract (row) {
      this.$router.push({
        name: 'businessDetails',
        params: { contractNum: row.contractNum },
        query: { distributeFlag: true, type: 3, id: row.contractId, isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
      });
    },
    /**
     * 申请发货单详情
     * @param row
     */
    lookDelivery (row) {
      this.currentClickData = row;
      this.dialogVisibleFromApplyForDelivery = true;
    },
    updateDialogVisibleFromApplyForDelivery (value) {
      this.dialogVisibleFromApplyForDelivery = value;
    },
    /**
     * 撤回弹窗
     */
    handleRevocation (row) {
      this.currentClickData = row;
      this.dialogVisibleFormRevocation = true;
    },
    updateDialogVisibleFromRevocation (value) {
      this.dialogVisibleFormRevocation = value;
    }
  },
  mounted () {
    this.handleSearch();
  }
};
</script>

<style scoped>

</style>
